var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "700" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" Gebruiker toestelen"),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _vm.devices.length == 0
        ? _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [_c("w-col", [_vm._v("Nog geen toestellen aangemaakt")])],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-list" } },
        [
          _vm._l(_vm.devices, function (device) {
            return _c(
              "w-list-item",
              { key: device.id },
              [
                _c("w-list-item-text", [
                  _c("div", [_vm._v(_vm._s(device.name))]),
                  _c("div", { staticClass: "device-id" }, [
                    _vm._v(_vm._s(device.deviceId)),
                  ]),
                ]),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.editDevice(device)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "pen" } })],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        staticClass: "danger",
                        on: {
                          click: function ($event) {
                            return _vm.deleteDevice(device)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "trash" } })],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c(
            "w-list-item",
            {
              on: {
                click: function ($event) {
                  return _vm.createNewDevice()
                },
              },
            },
            [
              _c(
                "w-list-item-icon",
                [_c("w-fa", { attrs: { icon: "plus" } })],
                1
              ),
              _c("w-list-item-text", [_vm._v("Nieuw toestel aanmaken")]),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditDevice != null } },
        [
          _vm.toEditDevice != null
            ? _c("app-company-edit-user-device-edit", {
                attrs: {
                  "company-id": _vm.companyId,
                  device: _vm.toEditDevice,
                },
                on: {
                  close: function ($event) {
                    return _vm.closeEdit()
                  },
                  input: function ($event) {
                    return _vm.onSaveDevice()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }